module.exports = __webpack_public_path__ + "img/Centurion-Relationship-Manager-service-2.b7f448c4.jpg";